import { render, staticRenderFns } from "./HomeVantageSummary.vue?vue&type=template&id=26966ebf&"
import script from "./HomeVantageSummary.vue?vue&type=script&lang=js&"
export * from "./HomeVantageSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26966ebf')) {
      api.createRecord('26966ebf', component.options)
    } else {
      api.reload('26966ebf', component.options)
    }
    module.hot.accept("./HomeVantageSummary.vue?vue&type=template&id=26966ebf&", function () {
      api.rerender('26966ebf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Tabs/HomeVantageSummary.vue"
export default component.exports